<template>
  <div class="col">
    <div class="row">
      <h2>Recherche par pays</h2>
    </div>
    <div class="row form">
      <select
        v-model.lazy="selectedCountry"
        class="field"
      >
        <option value="">
          -- Choisissez une valeur --
        </option>
        <option
          v-for="country in countries"
          :key="country.id"
          :value="country.id"
        >
          {{ country.name }}
        </option>
      </select>
      <custom-button
        class="limited-width"
        @click.native="search-by-country"
      >
        <i class="fas fa-search"></i>
        Rechercher
      </custom-button>
    </div>
    <div class="row">
      <SearchResult :search="chosenCountry"></SearchResult>
    </div>
  </div>
</template>

<script>
  import SearchResult from './search-result';
  import { sortedAndFilteredCountries }from './../resources/countries';
  import CustomButton from './micro-components/custom-button';

  export default {
    name: 'Search',
    components: { CustomButton, SearchResult },
    data() {
      return {
        countries: [],
        selectedCountry: '',
        chosenCountry: '',
      };
    },
    created() {
      this.countries = sortedAndFilteredCountries;
    },
    methods: {
      search() {
        this.chosenCountry = this.selectedCountry;
      }
    }
  };
</script>

<style scoped>
    h2 {
        margin: 0 0 0.3em 0;
    }

    .row {
        justify-content: center;
    }

    .limited-width {
        max-width: 150px;
    }

    .field {
        margin-right: 1em;
    }

    @media screen and (max-width: 500px){
        .form {
            flex-flow: column;
            width: 100%;
            justify-content: center;
        }

        .limited-width, .field {
            margin: 0.5em auto;
            width: 90%;
            max-width: none;
        }
    }
</style>
